import Api from "@/app/service/api";
import ApiError from "@/app/model/ApiError";
import OtpData from "@/app/model/OtpData";
// @ts-ignore
import crypto from "crypto";
import { ICommunicationError } from "@hc-hefaistos/hc-talk-talk";
import SetPasswordRequest from "@/app/dto/SetPasswordRequest";

class Password {
    public setPassword(password: string, customerUuid: string, otp: OtpData, authKey: string): Promise<void> {
        return new Promise((resolve, reject) => {
            const request = new SetPasswordRequest(
                this.createSha256HashWith1000Iterations(password)
            );
            Api.setPassword(customerUuid, authKey, otp, request)
                .then((response: any) => {
                    resolve();
                })
                .catch((error: ICommunicationError) => {
                    reject(new ApiError(error));
                });
        });
    }

    private createSha256HashWith1000Iterations(value: string): string {
        // @ts-ignore
        const buffer = Buffer.from(value, "utf8");
        let hash = crypto.createHash("sha256");
        hash.update(buffer);
        let digest = hash.digest();
        for (let index = 1; index < 1000; index++) {
            hash = crypto.createHash("sha256");
            hash.update(digest);
            digest = hash.digest();
        }

        return digest.toString("hex");
    }
}

export default new Password();
